/* BOコード */
export default {
    // ベネフィットステーション
    BS: "CR"
}